export default __webpack_public_path__ + "static/media/django-plain.0992085e.svg";